
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5jmoH", function(module, exports) {
$parcel$export(module.exports, "WidgetLoadingState", function () { return (parcelRequire("1YBxD")).WidgetLoadingState; });
parcelRequire("1YBxD");

});
parcelRegister("1YBxD", function(module, exports) {

$parcel$export(module.exports, "WidgetLoadingState", function () { return $38b27de52eb513e1$export$7e27a2e8e18ffe9b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $2nOeJ = parcelRequire("2nOeJ");
const $38b27de52eb513e1$var$Header = (0, $gRonV.default).div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`;
const $38b27de52eb513e1$var$Content = (0, $gRonV.default).div`
    height: ${({ height: height })=>height ?? "100px"};
    border-radius: 8px;
`;
const $38b27de52eb513e1$var$Button = (0, $gRonV.default).div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`;
const $38b27de52eb513e1$export$7e27a2e8e18ffe9b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function WidgetLoadingState({ title: title, headerButton: headerButton, height: height }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        "data-testid": "widgetLoadingState",
        title: title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Header, {
            className: "shimmer-container"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Button, {
            className: "shimmer-container"
        }),
        ...headerButton && {
            headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Button, {
                className: "shimmer-container sm"
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Content, {
        className: "shimmer-container",
        height: height
    }));
});

});


parcelRegister("faL8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $017a179eb6a08d2f$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
function $017a179eb6a08d2f$export$2e2bcd8739ae039(callback, delay, runOnInit) {
    const savedCallback = (0, $7E7Dk.useRef)();
    (0, $7E7Dk.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $7E7Dk.useEffect)(()=>{
        function tick() {
            if (typeof savedCallback.current === "function") savedCallback.current();
        }
        if (runOnInit) tick();
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>{
                clearInterval(id);
            };
        }
    }, [
        delay,
        runOnInit
    ]);
}

});

parcelRegister("i2XhI", function(module, exports) {
$parcel$export(module.exports, "Alert", function () { return (parcelRequire("1eyKz")).Alert; });
parcelRequire("1eyKz");

});
parcelRegister("1eyKz", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $ac7511a58ae5c45a$export$caec2af78bcc877f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
const $ac7511a58ae5c45a$var$SAlert = (0, $gRonV.default).div`
    color: ${({ theme: theme })=>theme.font.darkestColor};
    background-color: ${({ theme: theme, error: error })=>error ? theme.brandColors.CA_Light_Coral : theme.brandColors.CA_Light_Green};
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
`;
function $ac7511a58ae5c45a$export$caec2af78bcc877f({ dataTestId: dataTestId, className: className, style: style, error: error, message: message }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ac7511a58ae5c45a$var$SAlert, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        error: error,
        "data-testid": dataTestId ?? "alert-" + (error ? "error" : "success")
    }, message);
}

});



var $7E7Dk = parcelRequire("7E7Dk");

var $9Sg2u = parcelRequire("9Sg2u");

var $3um4r = parcelRequire("3um4r");

var $2rQNl = parcelRequire("2rQNl");

var $eHYdO = parcelRequire("eHYdO");

var $aLIw2 = parcelRequire("aLIw2");

var $1iD12 = parcelRequire("1iD12");

var $1IBeB = parcelRequire("1IBeB");

var $aCffN = parcelRequire("aCffN");

var $9p3YO = parcelRequire("9p3YO");

var $10c6O = parcelRequire("10c6O");
var $gtjDQ = parcelRequire("gtjDQ");

var $eLH3C = parcelRequire("eLH3C");

var $7JRAZ = parcelRequire("7JRAZ");

var $hw820 = parcelRequire("hw820");

var $eFTdF = parcelRequire("eFTdF");

var $jnDYy = parcelRequire("jnDYy");
const $70f912f5d483b5ef$var$createRootReducers = ()=>{
    const rootReducerFn = (0, $10c6O.combineReducers)({
        entitlements: (0, $hw820.default),
        portalSessionReset: (0, $eFTdF.default),
        user: (0, $jnDYy.default),
        [(0, $7JRAZ.enhancedApi).reducerPath]: (0, $7JRAZ.enhancedApi).reducer
    });
    return (state, action)=>{
        return rootReducerFn((0, $jnDYy.reset) && action.type === (0, $jnDYy.reset).type ? undefined : state, action);
    };
};
const $70f912f5d483b5ef$export$6f57813fe9f31bf9 = (0, $gtjDQ.configureStore)({
    reducer: $70f912f5d483b5ef$var$createRootReducers(),
    devTools: false,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
            (0, $7JRAZ.enhancedApi).middleware
        ])
});
(0, $eLH3C.setupListeners)($70f912f5d483b5ef$export$6f57813fe9f31bf9.dispatch);
const $70f912f5d483b5ef$export$1b3de3898efde2ba = (preloadedState)=>{
    return (0, $gtjDQ.configureStore)({
        reducer: $70f912f5d483b5ef$var$createRootReducers(),
        preloadedState: preloadedState,
        devTools: false,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
                (0, $7JRAZ.enhancedApi).middleware
            ])
    });
};



var $7E7Dk = parcelRequire("7E7Dk");

var $4AX6R = parcelRequire("4AX6R");
var $3um4r = parcelRequire("3um4r");

var $9Rf8k = parcelRequire("9Rf8k");

var $f0ov8 = parcelRequire("f0ov8");

var $aojuQ = parcelRequire("aojuQ");

var $dm5pM = parcelRequire("dm5pM");

var $a4GLo = parcelRequire("a4GLo");

var $PmdvF = parcelRequire("PmdvF");

var $kNBIm = parcelRequire("kNBIm");

var $7E7Dk = parcelRequire("7E7Dk");

var $9Wtn2 = parcelRequire("9Wtn2");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $hhXpq = parcelRequire("hhXpq");

var $gUTZf = parcelRequire("gUTZf");

var $7YeJw = parcelRequire("7YeJw");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $4gSsL = parcelRequire("4gSsL");

var $1hIPE = parcelRequire("1hIPE");
const $da9732d1cba6891e$var$Wrapper = (0, $gRonV.default).div`
    display: flex;
    gap: 4px;
    width: 32px;
`;
function $da9732d1cba6891e$export$8df3070cb8568cb1({ chargingSession: chargingSession }) {
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    if (chargingSession.productId && chargingSession.productId < 4) {
        if (chargingSession.connectorFunctionType === "Charger") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-car",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa icon-socket",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
        });
    }
    if ((0, $1hIPE.default)(chargingSession)) {
        if (chargingSession.connectorId === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da9732d1cba6891e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-circle",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? ""),
            "data-testid": "leftConnector"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-circle-o"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da9732d1cba6891e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-circle-o"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-circle",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? ""),
            "data-testid": "rightConnector"
        }));
    }
    if (chargingSession.productId === 7) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "fa fa-car",
        title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "emptyDiv"
    });
}





var $jwHtR = parcelRequire("jwHtR");

var $2nOeJ = parcelRequire("2nOeJ");

var $7PpdL = parcelRequire("7PpdL");

var $5u6k9 = parcelRequire("5u6k9");
const $fd75723863ee2054$var$THead = (0, $gRonV.default).thead`
    height: 40px;
`;
const $fd75723863ee2054$var$TTitle = (0, $gRonV.default).th`
    font-size: 14px;
`;
const $fd75723863ee2054$var$ButtonContainer = (0, $gRonV.default).div`
    display: flex;
    width: inherit;
    align-items: center;
    justify-content: center;
`;
const $fd75723863ee2054$export$c9346c8390d51ce8 = 10;
function $fd75723863ee2054$export$d96ee243323785bc({ sessions: sessions, loadMoreChargingSessions: loadMoreChargingSessions, loading: loading, showEndTime: showEndTime }) {
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblMyLatestChargingSessionsWidget"),
        "data-testid": "latest-charging-session"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "table-container",
        "data-testid": "chargingSessionContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("table", {
        className: "table table-striped table-hover"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$THead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$TTitle, {
        className: "heading5",
        "data-testid": "row-charger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblCharger"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$TTitle, {
        className: "heading5",
        "data-testid": "row-socket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSocket"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$TTitle, {
        className: "heading5",
        "data-testid": "row-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblStart"
    })), showEndTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$TTitle, {
        className: "heading5",
        "data-testid": "row-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblStop"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$TTitle, {
        className: "heading5",
        "data-testid": "row-total"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblTotalKWh"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("tbody", null, sessions?.map((session, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
            className: "text5",
            "data-testid": `name-${i}`
        }, session.chargePointName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
            className: "text5",
            "data-testid": `icons-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $da9732d1cba6891e$export$8df3070cb8568cb1), {
            chargingSession: session
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
            className: "text5",
            "data-testid": `startTime-${i}`
        }, (0, $jwHtR.dateLocalize)(session.startTime)), showEndTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
            className: "text5",
            "data-testid": `endTime-${i}`
        }, (0, $jwHtR.dateLocalize)(session.endTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
            className: "text5",
            "data-testid": `totalKwH-${i}`
        }, session?.totalConsumptionKwh?.toFixed(3))))))), loadMoreChargingSessions && (0, $7PpdL.isMoreItemsToLoad)($fd75723863ee2054$export$c9346c8390d51ce8, sessions.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fd75723863ee2054$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnLoadMore"),
        icon: "pi pi-chevron-down",
        iconPos: "right",
        onClick: ()=>loadMoreChargingSessions(),
        loading: loading
    })));
}





var $1O9Jh = parcelRequire("1O9Jh");

var $1gy6g = parcelRequire("1gy6g");

var $54O4W = parcelRequire("54O4W");

var $33umL = parcelRequire("33umL");

var $4uFSF = parcelRequire("4uFSF");

var $9Lv7o = parcelRequire("9Lv7o");

var $5DZBN = parcelRequire("5DZBN");
parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $faL8c = parcelRequire("faL8c");

var $1sDHO = parcelRequire("1sDHO");

var $rLEIN = parcelRequire("rLEIN");

var $f12mB = parcelRequire("f12mB");

var $5u6k9 = parcelRequire("5u6k9");

var $7u8z6 = parcelRequire("7u8z6");

var $1hIPE = parcelRequire("1hIPE");

var $3rYDT = parcelRequire("3rYDT");

var $hohPv = parcelRequire("hohPv");

var $lFIQ9 = parcelRequire("lFIQ9");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $hWELq = parcelRequire("hWELq");

var $1sDHO = parcelRequire("1sDHO");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");
const $20060990f46aa4c4$var$getGreenChargingAppLink = ()=>{
    const language = (0, $1sDHO.default).getItem("userLocale");
    const notLocalized = [
        "en",
        "fr",
        "nl",
        "es",
        "pt"
    ];
    if (!language || notLocalized.includes(language.toString())) return "https://www.chargeamps.com/chargeamps-app/";
    return `https://www.chargeamps.com/${language}/chargeamps-app/`;
};
function $20060990f46aa4c4$export$75ed7dfd858fd56a({ visible: visible, className: className, style: style, close: close, onAccept: onAccept }) {
    const text = (0, $5u6k9.default)();
    const handleClose = ()=>{
        close();
        onAccept();
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnClose"),
        type: "button",
        onClick: handleClose,
        "data-testid": "green-charging-close"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: handleClose,
        header: text("lblGreenChargingDialogTitle"),
        footer: footer,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "green-charging-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column align-items-center gap-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hWELq.GreenChargingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "w-full max-w-22rem text-center line-height-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgGreenChargingDialogDescription",
        values: {
            link: {
                href: $20060990f46aa4c4$var$getGreenChargingAppLink(),
                target: "_blank",
                rel: "noopener noreferrer"
            }
        }
    }))));
}




function $92985d883f00a125$export$ab6746011d315456() {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    /*************/ /** States  **/ /*************/ const [showGreenChargingDialog, setShowGreenChargingDialog] = (0, $7E7Dk.useState)(false);
    const [chargePointIds, setChargePointIds] = (0, $7E7Dk.useState)([]);
    const [auraChargePoints, setAuraChargePoints] = (0, $7E7Dk.useState)([]);
    const [haloChargePoints, setHaloChargePoints] = (0, $7E7Dk.useState)([]);
    const [dawnChargePoints, setDawnChargePoints] = (0, $7E7Dk.useState)([]);
    const [lunaChargePoints, setLunaChargePoints] = (0, $7E7Dk.useState)([]);
    const [allReadOnly, setAllReadOnly] = (0, $7E7Dk.useState)(false);
    /*************/ /** Request **/ /*************/ /** Get user statistics **/ const { data: userStatistics } = (0, $1O9Jh.useStatisticsGetUserUsageStatisticsQuery)({
        userId: user.id
    }, {
        skip: !user.id
    });
    /*************************/ /** Get charging sessions **/ const { data: chargingSessions, isLoading: chargingSessionLoading } = (0, $1O9Jh.useChargingSessionGetChargingSessionsForCurrentUserQuery)({
        noOfItems: 7
    }, {
        skip: !user.id
    });
    /**************************/ const [getChargePoints, { data: chargePoints, isSuccess: isSuccess, isLoading: isLoading }] = (0, $1O9Jh.useLazyUserGetOwnedChargePointsWithIdsQuery)();
    const [updateUserGreenChargingSetting] = (0, $1O9Jh.useUserUpdateUserGreenChargingSettingMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (isSuccess && chargePoints) {
            const chargePointIds = chargePoints.map((nextChargePoint)=>{
                return nextChargePoint?.id;
            });
            setChargePointIds(chargePointIds);
            if (!chargePointIds) navigate("/registerchargepoint");
            else {
                if ((0, $1sDHO.default).getItem("showGreenChargingModal")) setShowGreenChargingDialog(true);
                if (chargePoints) setAllReadOnly(chargePoints.find((cp)=>cp.ownerReadOnly === false) ? false : true);
                const auraChargePoints = chargePoints.filter((c)=>(0, $1hIPE.default)(c));
                setAuraChargePoints(auraChargePoints);
                const haloChargePoints = chargePoints.filter((c)=>(0, $3rYDT.default)(c));
                setHaloChargePoints(haloChargePoints);
                const dawnChargePoints = chargePoints.filter((c)=>(0, $hohPv.default)(c));
                setDawnChargePoints(dawnChargePoints);
                const lunaChargePoints = chargePoints.filter((c)=>(0, $lFIQ9.default)(c));
                setLunaChargePoints(lunaChargePoints);
            }
        }
    }, [
        isSuccess,
        chargePoints,
        navigate
    ]);
    /**************************/ /** Hide Green Charging Dialog **/ const setInformed = ()=>{
        if (user.id) updateUserGreenChargingSetting({
            userId: user.id
        });
        (0, $1sDHO.default).removeItem("showGreenChargingModal");
    };
    /********************************/ (0, $faL8c.default)(async ()=>{
        await getChargePoints({
            body: chargePointIds,
            expand: `${(0, $gUTZf.default).OcppConfig},${(0, $gUTZf.default).TopChargingLimitation}`
        });
    }, (0, $1gy6g.CHARGE_POINT_REFRESH_TIMEOUT) * 2, true);
    const isDesktopScreen = (0, $9Wtn2.useMediaPredicate)("(min-width: 900px)");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblHomePage",
        size: "lg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7YeJw.ChargingStatistics), {
        stats: userStatistics,
        direction: isDesktopScreen ? "row" : "column"
    })), allReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $rLEIN.default), {
        text: text("lblOwnerReadOnlyActivatedMultiple"),
        alertType: (0, $rLEIN.AlertType).Info,
        "data-testid": "ownerReadOnlyActivated-msg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row margin-bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, haloChargePoints.map((c)=>{
        if (c.ocppServerMode === "Internal") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, {
            key: `${c.id}-halo-internal`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7u8z6.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9Lv7o.ChargePointOcppHaloControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4uFSF.ChargePointCapiHaloControlWidget), {
            key: `${c.id}-halo-capi`,
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        });
    }), auraChargePoints.map((c)=>{
        if (c.ocppServerMode === "Internal") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, {
            key: `${c.id}-aura-internal`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7u8z6.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $54O4W.ChargePointOcppAuraControlWidget), {
            chargePoint: c,
            userId: user?.id,
            isReadOnly: c.ownerReadOnly === true
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $33umL.ChargePointCapiAuraControlWidget), {
            key: `${c.id}-aura-capi`,
            chargePoint: c,
            userId: user?.id,
            isReadOnly: c.ownerReadOnly === true
        });
    }), dawnChargePoints.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, {
            key: `${c.id}-dawn`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7u8z6.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5DZBN.ChargePointDawnControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }))), lunaChargePoints.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, {
            key: `${c.id}-luna`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7u8z6.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f12mB.ChargePointLunaControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "285px"
    })), chargingSessions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-7",
        "data-testid": "Chargingsessionsection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fd75723863ee2054$export$d96ee243323785bc), {
        sessions: chargingSessions,
        showEndTime: false
    })), chargingSessionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-7",
        "data-testid": "Chargingsessionsection-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "450px"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $20060990f46aa4c4$export$75ed7dfd858fd56a), {
        visible: showGreenChargingDialog,
        onAccept: setInformed,
        close: ()=>setShowGreenChargingDialog(false)
    }));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $2rQNl = parcelRequire("2rQNl");

var $1XnpB = parcelRequire("1XnpB");

var $igvrl = parcelRequire("igvrl");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $eSg49 = parcelRequire("eSg49");

var $5u6k9 = parcelRequire("5u6k9");
const $83994c0a09b7b64a$var$SButtonGroup = (0, $gRonV.default).div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
    letter-spacing: 1%;
    gap: 8px;
    font-size: 16px;
`;
const $83994c0a09b7b64a$var$SText = (0, $gRonV.default).div`
    font-size: 20px;
    line-height: 38px;
    text-align: center;
    letter-spacing: 1%;
    a {
        color: #006ef0;
    }
    a:hover {
        cursor: pointer;
        color: #8abfff;
    }
`;
function $83994c0a09b7b64a$export$1ef146911fa9c3b({ cancel: cancel, accept: accept, errorMessage: errorMessage }) {
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2 solid"
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eSg49.SAlert), {
        type: "error",
        className: "margin-top-small",
        "data-testid": "alert-error"
    }, errorMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($83994c0a09b7b64a$var$SText, {
        className: "row margin-top-med margin-bottom-med",
        "data-testid": "info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgUserAgreementInfo",
        values: {
            link: {
                href: `https://www.chargeamps.com/${text("linkTermsOfService")}`,
                target: "_new"
            },
            link2: {
                href: `https://www.chargeamps.com/${text("linkPrivacyPolicy")}`,
                target: "_new"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($83994c0a09b7b64a$var$SButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnAccept"),
        onClick: ()=>accept(),
        "data-testid": "accept-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: ()=>cancel(),
        "data-testid": "cancel-btn"
    }))));
}





var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $jnDYy = parcelRequire("jnDYy");

var $20ecU = parcelRequire("20ecU");
const $37095695afb1ca08$var$SColumn = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $37095695afb1ca08$var$STitle = (0, $gRonV.default).div`
    color: #000000;
    letter-spacing: 1%;
    font-size: 30px;
`;
const $37095695afb1ca08$var$SChargeAmpsLandingPageLogo = (0, $gRonV.default)((0, $1XnpB.ChargeAmpsLandingPageLogo))`
    fill: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.darkestColor};
`;
function $37095695afb1ca08$export$5573dc5ce5740818() {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const user = (0, $20ecU.useSessionUser)();
    const [errorMessage, setErrorMessage] = (0, $7E7Dk.useState)(null);
    const [acceptTerms] = (0, $1O9Jh.useUserAcceptTermsMutation)();
    const cancel = ()=>{
        navigate("/login", {
            replace: true
        });
    };
    const handleAcceptTerms = ()=>{
        acceptTerms().unwrap().then(()=>{
            const updatedUser = {
                ...user,
                personalAccept: new Date().toDateString()
            };
            dispatch((0, $jnDYy.setUser)(updatedUser));
            navigate("/dashboard", {
                replace: true
            });
        }).catch(()=>setErrorMessage(text("msgErrorAcceptingTerms")));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "logo",
        "data-testid": "logo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($37095695afb1ca08$var$SChargeAmpsLandingPageLogo, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container",
        "data-testid": "container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($37095695afb1ca08$var$SColumn, {
        className: "row text-center heading",
        "data-testid": "tite-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($37095695afb1ca08$var$STitle, {
        className: "row",
        "data-testid": "title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblTermsOfServicePage"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $83994c0a09b7b64a$export$1ef146911fa9c3b), {
        cancel: cancel,
        accept: handleAcceptTerms,
        errorMessage: errorMessage
    }))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $aBfUs = parcelRequire("aBfUs");

var $eUJ8c = parcelRequire("eUJ8c");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $7FGDK = parcelRequire("7FGDK");

var $3um4r = parcelRequire("3um4r");

var $j26DE = parcelRequire("j26DE");

var $dXhIC = parcelRequire("dXhIC");

var $1O9Jh = parcelRequire("1O9Jh");

var $aoz19 = parcelRequire("aoz19");

var $3T14g = parcelRequire("3T14g");

var $eFd5W = parcelRequire("eFd5W");

var $7FZyo = parcelRequire("7FZyo");

var $igvrl = parcelRequire("igvrl");

var $ikjch = parcelRequire("ikjch");

var $7E7Dk = parcelRequire("7E7Dk");
var $834839ad0fe302b4$export$2e2bcd8739ae039 = (effect, deps)=>{
    const isInitialMount = (0, $7E7Dk.useRef)(true);
    (0, $7E7Dk.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else return effect();
    }, deps);
};



var $aBfUs = parcelRequire("aBfUs");

var $iUBfY = parcelRequire("iUBfY");

var $5u6k9 = parcelRequire("5u6k9");
const $e1d231c7e1873cb0$var$ContentWrapper = (0, $gRonV.default).div`
    width: 750px;
    font-size: 16px;
    padding: 0 10px;
`;
const $e1d231c7e1873cb0$var$Row = (0, $gRonV.default).div`
    display: flex;
    width: ${({ short: short })=>short ? "50%" : "100%"};
    gap: 40px;
    justify-content: space-between;

    @media screen and (max-width: 775px) {
        flex-direction: column;
        width: 100%;
        margin-bottom: 40px;
    }

    @media screen and (min-width: 776px) {
        & > *:first-child:nth-last-child(1) {
            padding-right: 20px;
        }
    }
`;
const $e1d231c7e1873cb0$var$Spacer = (0, $gRonV.default).div`
    margin-bottom: 30px;
`;
const $e1d231c7e1873cb0$var$AgreementContainer = (0, $gRonV.default).div`
    width: 70%;
    text-align: center;
    align-self: center;

    @media screen and (max-width: 775px) {
        width: 100%;
    }

    a {
        color: ${({ theme: theme })=>theme.brandColors.CA_Blue};
    }
`;
const $e1d231c7e1873cb0$var$Form = (0, $gRonV.default).form`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 776px) {
        gap: 40px;
    }
`;
const $e1d231c7e1873cb0$var$ReturnButton = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme: theme })=>theme.font.midDarkColor};

    &:hover {
        cursor: pointer;
    }
`;
const $e1d231c7e1873cb0$var$initialFormData = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: ""
};
function $e1d231c7e1873cb0$export$3bd2b4ee8d70ffe2({ className: className, style: style, setStatus: setStatus }) {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const [createUser, { isLoading: loading }] = (0, $1O9Jh.useAuthRegisterMutation)();
    const [formData, setFormData] = (0, $7E7Dk.useState)($e1d231c7e1873cb0$var$initialFormData);
    const [formErrors, setFormErrors] = (0, $7E7Dk.useState)($e1d231c7e1873cb0$var$initialFormData);
    const [signUpError, setSignUpError] = (0, $7E7Dk.useState)(undefined);
    const [showPassword, toggleShowPassword] = (0, $7E7Dk.useState)(false);
    const createUserSchema = ()=>$7FGDK.object().shape({
            firstName: $7FGDK.string().required(text("lblEnterFirstName")).max((0, $j26DE.MAX_FIRST_NAME_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $j26DE.MAX_FIRST_NAME_LENGTH)
            })),
            lastName: $7FGDK.string().required(text("lblEnterLastName")).max((0, $j26DE.MAX_LAST_NAME_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $j26DE.MAX_LAST_NAME_LENGTH)
            })),
            mobile: $7FGDK.string().required(text("lblEnterMobile")).max((0, $j26DE.MAX_MOBILE_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $j26DE.MAX_MOBILE_LENGTH)
            })),
            email: $7FGDK.string().email(text("lblInvalidEmail")).required(text("lblEnterEmail")).test("match", text("lblInvalidEmail"), (val)=>(0, $iUBfY.validateEmailFormat)(val ?? "")),
            password: $7FGDK.string().min((0, $j26DE.MIN_PASSWORD_LENGTH), text("msgPasswordToShortSignup")).required(text("msgPasswordToShortSignup"))
        });
    /** Remove error message when start typing */ (0, $834839ad0fe302b4$export$2e2bcd8739ae039)(()=>{
        if (signUpError) setSignUpError(undefined);
    }, [
        formData
    ]);
    /*******************************************/ const handleSubmit = async (event)=>{
        event.preventDefault();
        try {
            await createUserSchema().validate(formData, {
                abortEarly: false
            });
            setFormErrors(()=>$e1d231c7e1873cb0$var$initialFormData);
            await createUser({
                chargePointUser: {
                    ...formData,
                    personalAccept: new Date().toISOString()
                }
            }).unwrap();
            setStatus("success");
        } catch (error) {
            if (error instanceof $7FGDK.ValidationError) {
                setFormErrors((0, $dXhIC.formatValidationErrorData)(error, $e1d231c7e1873cb0$var$initialFormData) || $e1d231c7e1873cb0$var$initialFormData);
                return;
            }
            const errorMessageCode = (0, $aoz19.getErrorMessageCode)(error);
            if (errorMessageCode) setSignUpError(text(errorMessageCode));
            else setStatus("failed");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$ContentWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Spacer, null, signUpError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SNotification), {
        "data-testid": "notificationError",
        error: true
    }, signUpError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Spacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Form, {
        onSubmit: handleSubmit,
        noValidate: true,
        autoComplete: "off"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.firstName.length > 0 ? text("lblFirstName") : "",
        errorTestId: "signUpFirstNameErrorMsg",
        errorMsg: formErrors.firstName,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.SInput), {
        "data-testid": "firstNameInput",
        type: "text",
        placeholder: text("lblFirstName"),
        onChange: (e)=>setFormData({
                ...formData,
                firstName: e.target.value
            }),
        autoFocus: true,
        formNoValidate: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.lastName.length > 0 ? text("lblLastNameShortField") : "",
        errorTestId: "signUpLastNameErrorMsg",
        errorMsg: formErrors.lastName,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.SInput), {
        "data-testid": "lastNameInput",
        type: "text",
        placeholder: text("lblLastNameShortField"),
        onChange: (e)=>setFormData({
                ...formData,
                lastName: e.target.value
            }),
        formNoValidate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.email.length > 0 ? text("lblEmail") : "",
        errorTestId: "signUpEmailErrorMsg",
        errorMsg: formErrors.email,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.SInput), {
        "data-testid": "emailInput",
        name: "email",
        type: "email",
        placeholder: text("lblEmail"),
        onChange: (e)=>setFormData({
                ...formData,
                email: e.target.value
            }),
        formNoValidate: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.mobile.length > 0 ? text("lblContactNumberShortField") : "",
        errorTestId: "signUpMobileErrorMsg",
        errorMsg: formErrors.mobile,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.SInput), {
        "data-testid": "mobileInput",
        type: "text",
        placeholder: text("lblContactNumberShortField"),
        onChange: (e)=>setFormData({
                ...formData,
                mobile: e.target.value
            }),
        formNoValidate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$Row, {
        short: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ikjch.PasswordInput), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.password.length > 0 ? text("lblPassword") : "",
        errorTestId: "signUpPasswordErrorMsg",
        error: formErrors.password,
        placeholder: text("lblPassword"),
        showPassword: showPassword,
        toggleShowPasswordFlag: toggleShowPassword,
        onChange: (value)=>setFormData({
                ...formData,
                password: value
            }),
        hasText: formData.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$AgreementContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgUserAgreementSignUpInfo",
        values: {
            link: {
                href: `https://www.chargeamps.com/${text("linkLegal")}`,
                target: "_new"
            },
            link2: {
                href: `https://www.chargeamps.com/${text("linkPrivacyPolicy")}`,
                target: "_new"
            }
        },
        "data-testid": "agreementText"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eFd5W.SubmitButton), {
        disabled: loading,
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "btnSignUp"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e1d231c7e1873cb0$var$ReturnButton, {
        onClick: ()=>navigate("/login"),
        "data-testid": "goToSignIn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblReturnToSignIn"
    }))));
}





var $5TMkT = parcelRequire("5TMkT");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $36ebc4f4d79428f0$var$Title = (0, $gRonV.default).div`
    font-size: 24px;
    margin-bottom: 20px;
`;
function $36ebc4f4d79428f0$export$265471dcab9022d3({ className: className, style: style }) {
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    const [status, setStatus] = (0, $7E7Dk.useState)("signup");
    (0, $7E7Dk.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, status === "signup" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1d231c7e1873cb0$export$3bd2b4ee8d70ffe2), {
        setStatus: setStatus
    }), status === "failed" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $5TMkT.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($36ebc4f4d79428f0$var$Title, {
        "data-testid": "errorTitle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "erroMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSignUpError"
    }))), status === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $5TMkT.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($36ebc4f4d79428f0$var$Title, {
        "data-testid": "successTitle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSignUpSuccessTitle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "successMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSignUpSuccess"
    }))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $gRonV = parcelRequire("gRonV");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $aBfUs = parcelRequire("aBfUs");

var $7FZyo = parcelRequire("7FZyo");

var $18mUD = parcelRequire("18mUD");

var $r38ZI = parcelRequire("r38ZI");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");

var $eUJ8c = parcelRequire("eUJ8c");

var $ljoiY = parcelRequire("ljoiY");

var $5u6k9 = parcelRequire("5u6k9");

var $c4hCO = parcelRequire("c4hCO");

var $1o9MR = parcelRequire("1o9MR");
const $65ef790a4de7c061$var$ButtonGroup = (0, $gRonV.default).div`
    padding-top: 15px;
    display: flex;
    justify-content: center;
    gap: 10px;
`;
const $65ef790a4de7c061$var$SSpacer = (0, $gRonV.default).div`
    margin-bottom: 49px;
`;
const $65ef790a4de7c061$var$SContentWrapper = (0, $gRonV.default)((0, $aBfUs.SContentWrapper))`
    max-width: 510px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $65ef790a4de7c061$var$SRegisterChargerInfo = (0, $gRonV.default).div`
    font-weight: var(--font-weight-light);
    font-size: 14px;
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    &,
    & > p {
        line-height: 22px;
    }
`;
const $65ef790a4de7c061$var$SWarningMessage = (0, $gRonV.default).div`
    display: flex;
    justify-content: space-around;
    font-size: 11px;
    border: 1px solid #a1a1a1;
    border-radius: 6px;
    padding: 15px 11px;
    margin-bottom: 10px;
`;
const $65ef790a4de7c061$var$SWarningMessageIcon = (0, $gRonV.default).span`
    margin-top: 2px;
    padding-right: 5px;
`;
function $65ef790a4de7c061$export$4a4cbf17073b70ff() {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const signOut = (0, $ljoiY.useSignOut)();
    const userId = (0, $2rQNl.useSelector)((state)=>state.user.id);
    const { register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors, isSubmitted: isSubmitted, isValid: isValid } } = (0, $cCnqE.useForm)({
        mode: "onSubmit",
        reValidateMode: "onChange",
        defaultValues: {
            chargePointId: "",
            name: "",
            wifiPassword: ""
        }
    });
    const nameLength = (0, $cCnqE.useWatch)({
        control: control,
        name: "name",
        defaultValue: ""
    }).trim().length;
    const [addChargerToUser] = (0, $1O9Jh.useChargePointSetOwnerMutation)();
    const doAddChargertoUser = async (data)=>{
        const name = data.name.trim();
        try {
            await addChargerToUser({
                userId: userId,
                chargePointId: data.chargePointId,
                name: name || data.chargePointId,
                wifiPassword: data.wifiPassword
            }).unwrap();
            navigate("/dashboard", {
                replace: true
            });
        } catch (error) {
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && (error.status === 409 || error.status === 404 || error.status === 403) && typeof error.data === "object" && error.data !== null && "error" in error.data && typeof error.data.error === "string") (0, $r38ZI.notifyError)(error.data.error);
            else (0, $r38ZI.notifyError)("msgChargerNotAddedtoUser");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.SFormHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblRegisterChargepointPage"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        "data-testid": "create-modal-form",
        onSubmit: handleSubmit(doAddChargertoUser),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        label: text("lblSerialNumber"),
        ...register("chargePointId", {
            required: {
                value: true,
                message: text("msgSerialNumberRequired")
            }
        }),
        id: "serialNumber",
        error: errors.chargePointId?.message,
        "data-testid": "serialNumber",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        label: text("lblPin"),
        id: "charger-pin",
        ...register("wifiPassword", {
            required: {
                value: true,
                message: text("msgPinCodeRequired")
            },
            maxLength: {
                value: 8,
                message: text("msgPinCodeLength")
            }
        }),
        error: errors?.wifiPassword?.message,
        "data-testid": "pinCode",
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "name",
        label: text("lblChargersNameField"),
        ...register("name", {
            validate: (value)=>value.trim().length <= (0, $c4hCO.MAX_NAME_LENGTH) || text("lblNameError")
        }),
        error: errors.name?.message,
        subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "flex justify-content-end"
        }, text("msgTextAreaCounter", {
            textCount: nameLength,
            maxLength: (0, $c4hCO.MAX_NAME_LENGTH)
        })),
        "data-testid": "name"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SWarningMessage, {
        "data-testid": "warningtext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SWarningMessageIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $18mUD.AlertIcon), {
        size: 20,
        fill: (0, $eUJ8c.theme).brandColors.CA_Blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblRegisterChargepointPageWarning"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$SRegisterChargerInfo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgRegisterChargerInfo"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($65ef790a4de7c061$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        outlined: true,
        onClick: signOut,
        "data-testid": "cancelBtn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnNext"),
        icon: "pi pi-arrow-right",
        iconPos: "right",
        type: "submit",
        "data-testid": "goBtn",
        disabled: isSubmitted && !isValid
    }))))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1O9Jh = parcelRequire("1O9Jh");

var $9c3iL = parcelRequire("9c3iL");

var $33umL = parcelRequire("33umL");

var $4uFSF = parcelRequire("4uFSF");

var $hDXS9 = parcelRequire("hDXS9");

var $5DZBN = parcelRequire("5DZBN");

var $54O4W = parcelRequire("54O4W");

var $9Lv7o = parcelRequire("9Lv7o");

var $gUTZf = parcelRequire("gUTZf");

var $hhXpq = parcelRequire("hhXpq");

var $1hIPE = parcelRequire("1hIPE");

var $hohPv = parcelRequire("hohPv");

var $3rYDT = parcelRequire("3rYDT");
parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $9c3iL = parcelRequire("9c3iL");

var $9yRvd = parcelRequire("9yRvd");

var $2OWYS = parcelRequire("2OWYS");

var $eIymc = parcelRequire("eIymc");

var $5aWjz = parcelRequire("5aWjz");

var $2nOeJ = parcelRequire("2nOeJ");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $20ecU = parcelRequire("20ecU");
const $ae3c4bf8bb1ae81a$var$SDisabledOverlay = (0, $gRonV.default).div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(212, 212, 212, 0.5);
    z-index: 1;
`;
const $ae3c4bf8bb1ae81a$var$OpenSmartScheduleButton = ({ chargePoint: chargePoint, existing: existing, isGreenChargingEnabled: isGreenChargingEnabled, loading: loading, enabled: enabled })=>{
    const text = (0, $5u6k9.default)();
    const hasSmartScheduleSupport = (0, $7E7Dk.useMemo)(()=>(0, $9c3iL.doesSupportSmartSchedule)(chargePoint), [
        chargePoint
    ]);
    const link = `${(0, $eIymc.isUserappDomain) ? "/remotecontrol" : "/chargepoints"}/${chargePoint.id}/schedule`;
    const disabled = isGreenChargingEnabled || !hasSmartScheduleSupport;
    const buttonLabel = ()=>{
        if (!existing) return text("lblCreateScheduleLink");
        return text(enabled ? "btnEditSchedule" : "btnViewSchedule");
    };
    const buttonProps = {
        label: buttonLabel(),
        icon: "pi pi-calendar",
        "data-testid": "link-to-smart"
    };
    return disabled || loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        ...buttonProps,
        loading: loading,
        disabled: disabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        "aria-label": buttonProps.label,
        className: "p-button p-component",
        "data-testid": buttonProps["data-testid"],
        to: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        "aria-hidden": "true",
        className: "p-button-icon p-c p-button-icon-left pi pi-calendar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "p-button-label p-c"
    }, buttonProps.label));
};
const $ae3c4bf8bb1ae81a$export$3eb892732573ae85 = ({ chargePoint: chargePoint, isGreenChargingEnabled: isGreenChargingEnabled, loading: loading })=>{
    const text = (0, $5u6k9.default)();
    const user = (0, $20ecU.useSessionUser)();
    const userHasEditRights = (0, $7E7Dk.useMemo)(()=>(0, $2OWYS.default)(chargePoint, user), [
        chargePoint,
        user
    ]);
    const { data: schedules } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id || ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, userHasEditRights && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblSchedulingWidget"),
        "data-testid": "smart-scheduling-widget",
        loadingStatus: loading,
        actionButtons: userHasEditRights && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9yRvd.SButtonsGroupContainer), {
            className: "action-btns"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ae3c4bf8bb1ae81a$var$OpenSmartScheduleButton, {
            chargePoint: chargePoint,
            existing: !!schedules?.length,
            isGreenChargingEnabled: isGreenChargingEnabled,
            loading: loading,
            enabled: userHasEditRights
        }))
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-medium"
    }) : isGreenChargingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5aWjz.GreenChargingBadge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ae3c4bf8bb1ae81a$var$SDisabledOverlay, null)) : null));
};





var $lFIQ9 = parcelRequire("lFIQ9");

var $f12mB = parcelRequire("f12mB");

var $7u8z6 = parcelRequire("7u8z6");

var $1gy6g = parcelRequire("1gy6g");

var $r38ZI = parcelRequire("r38ZI");

var $5u6k9 = parcelRequire("5u6k9");

var $20ecU = parcelRequire("20ecU");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $56EgM = parcelRequire("56EgM");

var $5u6k9 = parcelRequire("5u6k9");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");

var $9w3V4 = parcelRequire("9w3V4");

var $1o9MR = parcelRequire("1o9MR");

var $5ZFCf = parcelRequire("5ZFCf");

var $aCffN = parcelRequire("aCffN");
const $1d4c966c31f9248f$var$getGrantErrorMessageKey = (error)=>{
    if (!(0, $gGcRO.isFetchBaseQueryError)(error)) return "msgServicePartnerAccessGrantFailed";
    switch(error.status){
        case 403:
            return "msgServicePartnerAccessUnavailable";
        case 404:
            return "msgServicePartnerAccessInvalidCode";
        case 400:
            return "msgServicePartnerAccessRequestInvalid";
        case 409:
            return "msgServicePartnerAccessRequestRejected";
        case 410:
            return "msgServicePartnerAccessCodeExpired";
        default:
            return "msgServicePartnerAccessGrantFailed";
    }
};
function $1d4c966c31f9248f$export$1f3cb238d87f8dde({ chargePointId: chargePointId, isAccessAvailable: isAccessAvailable }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const [isAuthorised, setIsAuthorised] = (0, $7E7Dk.useState)(false);
    const [grantServicePartnerAccess, { isLoading: isGranting }] = (0, $1O9Jh.useChargePointAddServicePartnerMutation)();
    const { handleSubmit: handleSubmit, register: register, reset: reset, setValue: setValue, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: {
            partnerReferenceCode: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const partnerReferenceCodeRegistration = register("partnerReferenceCode", {
        required: text("msgServicePartnerCodeRequired"),
        validate: (value)=>value.trim().length === 8 || text("msgServicePartnerCodeInvalid")
    });
    const grantAccess = async ({ partnerReferenceCode: partnerReferenceCode })=>{
        if (!isAuthorised) return;
        try {
            await grantServicePartnerAccess({
                chargePointId: chargePointId,
                addServicePartnerByCodeRequest: {
                    code: partnerReferenceCode.trim()
                }
            }).unwrap();
            toast.notifySuccess(text("msgServicePartnerAccessGranted"));
            reset();
            setIsAuthorised(false);
        } catch (error) {
            toast.notifyError(text($1d4c966c31f9248f$var$getGrantErrorMessageKey(error)));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5ZFCf.Panel), {
        title: text("lblServicePartnerAccessWidgetTitle"),
        headerIcon: "pi pi-shield",
        headerActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9w3V4.FieldInfoButton), {
            ariaLabel: text("lblMoreInformation"),
            text: text("msgServicePartnerAccessInformation"),
            testId: "service-partner-access-info-button"
        }),
        className: "mt-4",
        testId: "service-partner-access-widget"
    }, !isAccessAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0"
    }, text("msgServicePartnerAccessUnavailable")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "mt-0 text-color-secondary"
    }, text("msgServicePartnerAccessWidgetDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit(grantAccess),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "p-label required-label",
        htmlFor: "service-partner-access-reference-code"
    }, text("lblServicePartnerReferenceCode")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "service-partner-access-reference-code",
        "data-testid": "service-partner-access-reference-code",
        ...partnerReferenceCodeRegistration,
        onChange: (event)=>{
            setValue("partnerReferenceCode", event.target.value.toUpperCase(), {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: isSubmitted
            });
            setIsAuthorised(false);
        },
        error: errors.partnerReferenceCode?.message,
        disabled: isGranting || isSubmitting,
        placeholder: "ABCDEFGH",
        maxLength: 8,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2 mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
        inputId: "service-partner-access-authorisation",
        checked: isAuthorised,
        onChange: (event)=>setIsAuthorised(!!event.checked),
        disabled: isGranting || isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "service-partner-access-authorisation",
        className: "line-height-3"
    }, text("msgConfirmServicePartnerAccessAuthorised"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        label: text("btnGrantServicePartnerAccess"),
        className: "mt-3",
        disabled: !isAuthorised || isGranting || isSubmitting || isSubmitted && !isValid,
        loading: isGranting
    }))));
}




const $8e6378fbf8e335fa$var$Container = (0, $gRonV.default).div`
    margin-top: 40px;
`;
const $8e6378fbf8e335fa$var$ChargePointContainer = (0, $gRonV.default).div`
    margin-top: 40px;
    display: flex;

    @media screen and (max-width: 990px) {
        flex-direction: column;
    }
`;
const $8e6378fbf8e335fa$var$TabList = (0, $gRonV.default).div`
    display: flex;
    padding: 0 15px;
`;
const $8e6378fbf8e335fa$var$ShimmerTab = (0, $gRonV.default).div`
    width: 100px;
    height: 20px;
    border-radius: 4px;
`;
const $8e6378fbf8e335fa$var$Tab = (0, $gRonV.default).div`
    border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    border-radius: 6px 6px 0 0;
    border-bottom: none;
    padding: 10px 20px;
    background-color: ${({ theme: theme, selected: selected })=>selected ? theme.font.lightestColor : theme.brandColors.CA_Light_Gray};

    font-weight: var(--font-weight-light);
    &:hover {
        cursor: pointer;
    }
`;
const $8e6378fbf8e335fa$export$31f6100da20592ef = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserAppRemoteControlPage() {
    const text = (0, $5u6k9.default)();
    const user = (0, $20ecU.useSessionUser)();
    const [selectedChargePointId, setSelectedChargePointId] = (0, $7E7Dk.useState)();
    const [getGCData, { data: chargePointStatus }] = (0, $1O9Jh.useLazyGreenChargingChargePointStatusQuery)();
    const { data: chargePoints, isSuccess: isSuccess, isLoading: isLoading } = (0, $1O9Jh.useUserGetOwnedChargePointsQuery)({
        expand: `${(0, $gUTZf.default).OcppConfig},${(0, $gUTZf.default).TopChargingLimitation}`
    }, {
        pollingInterval: (0, $1gy6g.CHARGE_POINT_REFRESH_TIMEOUT)
    });
    const selectedChargePoint = chargePoints?.find((chargePoint)=>chargePoint.id === selectedChargePointId) ?? chargePoints?.[0];
    const canGrantServicePartnerAccess = !!(selectedChargePoint?.companyId && user.roles.some((role)=>role.companyId === selectedChargePoint.companyId));
    const getGreenChargingData = async (chargePointId)=>{
        await getGCData({
            chargePointId: chargePointId
        }).unwrap().catch(()=>(0, $r38ZI.notifyError)(text("msgFailedToGetGCData")));
    };
    const onTabClick = async (chargePoint)=>{
        setSelectedChargePointId(chargePoint.id);
        await getGreenChargingData(chargePoint.id);
    };
    /*************************************/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblRemoteControlPage",
        size: "lg",
        "data-testid": "header",
        loading: isLoading
    }), isSuccess && chargePoints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$TabList, null, chargePoints?.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$Tab, {
            selected: selectedChargePoint?.id === c.id,
            onClick: ()=>onTabClick(c),
            key: c.id,
            "data-testid": c.id
        }, c.name))), selectedChargePoint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$ChargePointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, (0, $3rYDT.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4uFSF.ChargePointCapiHaloControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $3rYDT.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9Lv7o.ChargePointOcppHaloControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $1hIPE.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $33umL.ChargePointCapiAuraControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly,
        userId: user?.id
    }), (0, $1hIPE.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $54O4W.ChargePointOcppAuraControlWidget), {
        userId: user?.id,
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $hohPv.default)(selectedChargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5DZBN.ChargePointDawnControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $lFIQ9.default)(selectedChargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f12mB.ChargePointLunaControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7u8z6.ChargePointStatusWidget), {
        chargePoint: selectedChargePoint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1d4c966c31f9248f$export$1f3cb238d87f8dde), {
        key: selectedChargePoint.id,
        chargePointId: selectedChargePoint.id,
        isAccessAvailable: canGrantServicePartnerAccess
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, !(0, $hohPv.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hDXS9.ChargePointCapiScheduledChargingWidget), {
        chargePoint: selectedChargePoint,
        isGreenChargingEnabled: chargePointStatus?.greenChargingStatus?.greenChargingOn
    }), (0, $9c3iL.canShowSmartScheduling)(selectedChargePoint, user?.isSuperAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ae3c4bf8bb1ae81a$export$3eb892732573ae85), {
        chargePoint: selectedChargePoint,
        isGreenChargingEnabled: chargePointStatus?.greenChargingStatus?.greenChargingOn
    })))) : null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$TabList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$Tab, {
        selected: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$ShimmerTab, {
        className: "shimmer-container"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8e6378fbf8e335fa$var$ChargePointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "285px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "285px"
    })))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $hhXpq = parcelRequire("hhXpq");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $j26DE = parcelRequire("j26DE");

var $hhXpq = parcelRequire("hhXpq");

var $d6Tic = parcelRequire("d6Tic");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");

var $1o9MR = parcelRequire("1o9MR");
const $9b0a9b7b1aababb3$var$emptyPasswordChange = ()=>({
        currentPassword: "",
        newPassword: "",
        passwordCompare: ""
    });
function $9b0a9b7b1aababb3$export$fb7f3eeb32bd6cd0({ className: className, style: style, onChange: onChange, openPasswordChange: openPasswordChange, setOpenPasswordChange: setOpenPasswordChange }) {
    const text = (0, $5u6k9.default)();
    const [passwordChange, setPasswordChange] = (0, $7E7Dk.useState)($9b0a9b7b1aababb3$var$emptyPasswordChange);
    const openForm = ()=>{
        setPasswordChange($9b0a9b7b1aababb3$var$emptyPasswordChange());
        setOpenPasswordChange(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("flex flex-column", className),
        style: style
    }, !openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("lblChangePasswordLink"),
        icon: "pi pi-lock",
        text: true,
        severity: "info",
        className: "align-self-start px-0",
        onClick: openForm,
        "data-testid": "openPasswordChange"
    }), openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3",
        "data-testid": "passwordChange"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h3", {
        className: "m-0 text-lg font-semibold"
    }, text("lblChangingPassword")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "currentPassword",
        label: text("lblCurrentPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    currentPassword: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        "data-testid": "currentPassword",
        className: "w-full md:w-20rem"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column md:flex-row gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "newPassword",
        label: text("lblNewPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    newPassword: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        minLength: 8,
        "data-testid": "newPassword",
        className: "flex-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "passwordCompare",
        label: text("lblConfirmPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    passwordCompare: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        "data-testid": "passwordCompare",
        className: "flex-1"
    }))));
}




parcelRequire("i2XhI");
var $1eyKz = parcelRequire("1eyKz");

var $2nOeJ = parcelRequire("2nOeJ");

var $5u6k9 = parcelRequire("5u6k9");

var $jnDYy = parcelRequire("jnDYy");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");
const $0ecb28bf4069333d$var$SContainer = (0, $gRonV.default).div`
    width: 100%;
`;
const $0ecb28bf4069333d$var$SForm = (0, $gRonV.default).form`
    display: flex;
    gap: 20px;
    flex-direction: column;
`;
const $0ecb28bf4069333d$var$SRow = (0, $gRonV.default).div`
    display: flex;
    gap: 12px;

    &.alignSelf {
        align-self: flex-end;
    }

    @media (max-width: 500px) {
        flex-direction: column;
    }
`;
const $0ecb28bf4069333d$var$SWrapper = (0, $gRonV.default).div`
    display: flex;
    gap: 12px;
    flex-direction: ${({ direction: direction })=>direction};
    justify-content: ${({ direction: direction })=>direction === "row" ? "space-between" : "center"};
`;
const $0ecb28bf4069333d$var$SInput = (0, $gRonV.default).input`
    width: 175px;
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;

    @media (max-width: 500px) {
        width: 100%;
    }
`;
function $0ecb28bf4069333d$export$b7b58f2e100445f7({ user: user, className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const { value: userDetails, apply: changeDetails } = (0, $d6Tic.default)(user);
    const [updateUser, { isLoading: isUpdating }] = (0, $1O9Jh.useUserUpdateLoggedInUserMutation)();
    const [openPasswordChange, setOpenPasswordChange] = (0, $7E7Dk.useState)(false);
    const [emptyFields, setEmptyFields] = (0, $7E7Dk.useState)([]);
    const [updateMessage, setUpdateMessage] = (0, $7E7Dk.useState)({
        message: null,
        type: null
    });
    const [passwordErrors, setPasswordErrors] = (0, $7E7Dk.useState)("");
    const getUpdateErrorMessage = (error)=>{
        if ((0, $gGcRO.isFetchBaseQueryError)(error) && error.data && typeof error.data === "object" && "messageCode" in error.data && typeof error.data.messageCode === "string") return text(error.data.messageCode);
        return text("msgProfileNotUpdated");
    };
    const handlePasswordChangeVisibility = (isOpen)=>{
        setOpenPasswordChange(isOpen);
        if (!isOpen) changeDetails({
            passwordChange: null
        });
    };
    /** Update field **/ const updateField = (field, value)=>{
        changeDetails({
            [field]: value
        });
        const missingFields = [
            ...emptyFields.filter((m)=>m.field !== field)
        ];
        if (field === "firstName" && !value.length) missingFields.push({
            message: text("msgFirstNameRequired"),
            field: "firstName"
        });
        if (field === "lastName" && !value.length) missingFields.push({
            message: text("msgLastNameRequired"),
            field: "lastName"
        });
        if (field === "mobile" && !value.length) missingFields.push({
            message: text("msgMobileRequired"),
            field: "mobile"
        });
        setEmptyFields(missingFields);
        if (updateMessage.type) setUpdateMessage({
            type: null,
            message: null
        });
    };
    /** Check if new password is too short **/ (0, $7E7Dk.useEffect)(()=>{
        if (userDetails.passwordChange?.newPassword && !(0, $j26DE.isPasswordLongEnough)(userDetails.passwordChange.newPassword)) setPasswordErrors(text("msgPasswordToShort"));
        else setPasswordErrors("");
    }, [
        text,
        userDetails.passwordChange
    ]);
    /***************************************/ /** Check password before sending request **/ const checkPasswordChange = (passwordChange)=>{
        const currentPassword = passwordChange?.currentPassword ?? "";
        const newPassword = passwordChange?.newPassword ?? "";
        const passwordCompare = passwordChange?.passwordCompare ?? "";
        if (!currentPassword.length) {
            setPasswordErrors(text("lblCurrentPasswordEmptyField"));
            return true;
        }
        if (!(0, $j26DE.isPasswordLongEnough)(newPassword)) {
            setPasswordErrors(text("msgPasswordToShort"));
            return true;
        }
        if (newPassword !== passwordCompare) {
            setPasswordErrors(text("msgPasswordFailedToUpdate"));
            return true;
        }
        return false;
    };
    /*******************************************/ /** Handle submit **/ const handleSubmit = async (e)=>{
        e.preventDefault();
        setUpdateMessage({
            message: null,
            type: null
        });
        if (openPasswordChange && checkPasswordChange(userDetails.passwordChange)) return;
        try {
            await updateUser({
                chargePointUser: userDetails
            }).unwrap();
            setUpdateMessage({
                message: openPasswordChange ? text("msgProfilePasswordUpdated") : text("msgProfileUpdated"),
                type: "Success"
            });
            dispatch((0, $jnDYy.setUser)(userDetails));
        } catch (error) {
            setUpdateMessage({
                message: getUpdateErrorMessage(error),
                type: "Error"
            });
        }
    };
    /*******************/ const widgetTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblMyProfileWidget",
        className: "myProfile"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: widgetTitle,
        "data-testid": "myProfile"
    }, emptyFields?.map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
            key: index,
            message: field.message,
            className: `${field.field}Error`,
            error: true
        })), passwordErrors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: passwordErrors,
        error: true,
        className: "passwordError"
    }), updateMessage.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: updateMessage.message,
        error: updateMessage.type === "Error",
        className: updateMessage.message.includes("password is incorrect") ? "passwordError" : `update${updateMessage.type}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SForm, {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SInput, {
        className: "form-control",
        placeholder: text("lblFirstName"),
        type: "text",
        name: "firstName",
        onChange: (e)=>updateField("firstName", e.target.value),
        value: userDetails.firstName,
        id: "firstName",
        maxLength: 100,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SInput, {
        className: "form-control",
        placeholder: text("lblLastNameField"),
        type: "text",
        name: "lastName",
        value: userDetails.lastName,
        onChange: (e)=>updateField("lastName", e.target.value),
        id: "lastName",
        maxLength: 100,
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SInput, {
        className: "form-control",
        placeholder: text("lblEmailAddressField"),
        type: "email",
        name: "email",
        value: user.email,
        required: true,
        readOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SInput, {
        className: "form-control",
        placeholder: text("lblMobilePhoneField"),
        type: "text",
        name: "mobile",
        value: userDetails?.mobile,
        onChange: (e)=>updateField("mobile", e.target.value),
        id: "mobile",
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SWrapper, {
        direction: openPasswordChange ? "column" : "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9b0a9b7b1aababb3$export$fb7f3eeb32bd6cd0), {
        user: userDetails,
        onChange: changeDetails,
        openPasswordChange: openPasswordChange,
        setOpenPasswordChange: handlePasswordChangeVisibility
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0ecb28bf4069333d$var$SRow, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            alignSelf: openPasswordChange
        })
    }, openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: ()=>handlePasswordChangeVisibility(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        label: text("btnSave"),
        icon: "pi pi-save",
        disabled: emptyFields.length > 0 || passwordErrors.length > 0,
        loading: isUpdating
    }))))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");

var $4gSsL = parcelRequire("4gSsL");

var $h9iNZ = parcelRequire("h9iNZ");

var $sVPXf = parcelRequire("sVPXf");

var $6K6p8 = parcelRequire("6K6p8");

var $1O9Jh = parcelRequire("1O9Jh");

var $1o9MR = parcelRequire("1o9MR");

var $MMfqT = parcelRequire("MMfqT");

var $aCffN = parcelRequire("aCffN");

var $4LjKQ = parcelRequire("4LjKQ");

var $34PLY = parcelRequire("34PLY");
const $edf95c8dd73a54c2$var$formId = "edit-charge-point-form";
function $edf95c8dd73a54c2$export$666b8e5b12c29656(props) {
    const { chargePoint: chargePoint } = props;
    if (!chargePoint) return null;
    const DialogContent = chargePoint.isOcpp ? $edf95c8dd73a54c2$var$OcppEditChargePointDialogContent : $edf95c8dd73a54c2$var$CapiEditChargePointDialogContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement(DialogContent, {
        key: chargePoint.id,
        ...props,
        chargePoint: chargePoint
    });
}
function $edf95c8dd73a54c2$var$OcppEditChargePointDialogContent(props) {
    const validationMethods = (0, $sVPXf.useOcppUserCurrentValidation)(props.chargePoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($edf95c8dd73a54c2$var$EditChargePointForm, {
        ...props,
        validationMethods: validationMethods
    });
}
function $edf95c8dd73a54c2$var$CapiEditChargePointDialogContent(props) {
    const validationMethods = (0, $6K6p8.useCapiUserCurrentValidation)(props.chargePoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($edf95c8dd73a54c2$var$EditChargePointForm, {
        ...props,
        validationMethods: validationMethods
    });
}
function $edf95c8dd73a54c2$var$EditChargePointForm({ chargePoint: chargePoint, visible: visible, onHide: onHide, onSaveSettled: onSaveSettled, editChargerName: editChargerName, validationMethods: validationMethods }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    const [edit, setEdit] = (0, $7E7Dk.useState)(false);
    const availableConnectors = (chargePoint.connectors ?? []).filter((connector)=>(0, $4LjKQ.isChargingConnector)(connector) && (connector.connectorId === 1 || connector.connectorId === 2)).sort((a, b)=>a.connectorId - b.connectorId);
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { isValid: isValid, isDirty: isDirty, isSubmitted: isSubmitted } } = validationMethods;
    const title = (0, $h9iNZ.getProductName)(chargePoint.productId);
    const readOnlyReason = chargePoint.ownerReadOnly ? text("msgNoPermissionToEditCharger") : undefined;
    const [updateChargePointUserSettings, { isLoading: isSaving }] = (0, $1O9Jh.useChargePointUpdateChargePointUserSettingsMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) {
            reset();
            setEdit(false);
        }
    }, [
        reset,
        visible
    ]);
    const saveChargePoint = async (formValues)=>{
        try {
            await updateChargePointUserSettings({
                chargePointId: chargePoint.id,
                name: formValues.name ?? "",
                userCurrentConnector1: formValues.uc_1,
                userCurrentConnector2: formValues.uc_2
            }).unwrap();
            toast.notifySuccess(text("msgChargerUpdated"));
        } catch  {
            toast.notifyError(text("msgChargePointNotUpdated"));
        } finally{
            onHide();
            onSaveSettled?.();
        }
    };
    const saveDisabled = !isDirty || isSubmitted && !isValid || !(0, $34PLY.default)(chargePoint) || chargePoint.ownerReadOnly || isSaving;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnSave"),
        type: "submit",
        form: $edf95c8dd73a54c2$var$formId,
        disabled: saveDisabled,
        loading: isSaving
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("lblChargerInfoDialogTitle"),
        footer: footer,
        "data-testid": "edit-charge-point-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $edf95c8dd73a54c2$var$formId,
        className: "flex flex-column gap-4",
        onSubmit: handleSubmit(saveChargePoint),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        className: "flex flex-column gap-3"
    }, edit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        type: "text",
        id: "name",
        label: text("lblName"),
        "data-testid": "name-input",
        required: true,
        ...register("name"),
        error: validationMethods.getFieldState("name").error?.message
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "text-xl font-medium"
    }, chargePoint.name), editChargerName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        icon: "pi pi-pencil",
        text: true,
        rounded: true,
        size: "small",
        severity: "info",
        disabled: chargePoint.ownerReadOnly,
        tooltip: readOnlyReason,
        tooltipOptions: {
            position: "top",
            showOnDisabled: true
        },
        "aria-label": text("lblEditChargerName"),
        onClick: ()=>setEdit(true),
        "data-testid": "toggle-name-edit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2 text-color-secondary",
        "data-testid": `chargePointType-${chargePoint.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, chargePoint.isOcpp ? text("lblOcpp") : text("lblCapiField")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        className: "flex flex-column gap-3"
    }, availableConnectors.map((connector)=>{
        const fieldName = `uc_${connector.connectorId}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
            key: connector.connectorId,
            type: "number",
            id: fieldName,
            label: text("lblCurrentLimitWithMaxVoltage", {
                connectorName: adaptConnectorNaming(connector.name),
                installationCurrent: connector.installationCurrent
            }),
            "data-testid": `userCurrent-input-${connector.connectorId}`,
            error: validationMethods.getFieldState(fieldName).error?.message,
            ...register(fieldName),
            disabled: isSaving || chargePoint.ownerReadOnly || chargePoint.isOcpp && chargePoint.chargePointStatus !== "Online",
            disabledReason: readOnlyReason
        });
    }))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $hhXpq = parcelRequire("hhXpq");
parcelRequire("i2XhI");
var $1eyKz = parcelRequire("1eyKz");

var $igvrl = parcelRequire("igvrl");

var $Ri8UW = parcelRequire("Ri8UW");
const $88886e07848a83b0$var$updateNfcTagsForCurrentUser = (tags)=>(0, $Ri8UW.default)({
        method: "PUT",
        path: "/users/nfctags/own",
        body: tags
    });
var $88886e07848a83b0$export$2e2bcd8739ae039 = $88886e07848a83b0$var$updateNfcTagsForCurrentUser;



var $Ri8UW = parcelRequire("Ri8UW");
const $d19ea9236ce7b098$var$loadLatestRejectedNfcForUser = ()=>(0, $Ri8UW.default)({
        path: `/users/nfctags/rejected`
    });
var $d19ea9236ce7b098$export$2e2bcd8739ae039 = $d19ea9236ce7b098$var$loadLatestRejectedNfcForUser;



var $23wDf = parcelRequire("23wDf");

var $2nOeJ = parcelRequire("2nOeJ");

var $Ri8UW = parcelRequire("Ri8UW");
const $55d7747fa069f0b8$var$loadNfcTagsForCurrentUser = ()=>(0, $Ri8UW.default)({
        path: "/users/nfctags/own"
    });
var $55d7747fa069f0b8$export$2e2bcd8739ae039 = $55d7747fa069f0b8$var$loadNfcTagsForCurrentUser;



var $5u6k9 = parcelRequire("5u6k9");
const $861b18ca24babdb9$var$SContainer = (0, $gRonV.default)((0, $2nOeJ.WidgetLayout))`
    width: 100%;
`;
const $861b18ca24babdb9$var$SForm = (0, $gRonV.default).form`
    display: flex;
    flex-direction: column;
`;
const $861b18ca24babdb9$var$SRow = (0, $gRonV.default).div`
    display: flex;
    gap: 12px;
    margin-bottom: 20px;

    &.alignSelf {
        align-self: flex-end;
        margin-bottom: 0;
    }
`;
const $861b18ca24babdb9$var$SInput = (0, $gRonV.default).input`
    width: 175px;
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
`;
function $861b18ca24babdb9$export$4151436cdd5efa83({ className: className, style: style, rfid1: rfid1, rfid2: rfid2, rfid3: rfid3 }) {
    const text = (0, $5u6k9.default)();
    const validateHexCode = (hex)=>{
        if (![
            8,
            14,
            20
        ].includes(hex.length)) return {
            isValid: false,
            error: text("msgRFIDNotAccepted")
        };
        const isValid = /^[0-9A-Fa-f]+$/g.test(hex);
        return {
            isValid: isValid,
            error: !isValid && text("msgInvalidHexadecimal")
        };
    };
    const [rfidOne, setRfidOne] = (0, $7E7Dk.useState)({
        id: "",
        comment: ""
    });
    const [rfidTwo, setRfidTwo] = (0, $7E7Dk.useState)({
        id: "",
        comment: ""
    });
    const [rfidThree, setRfidThree] = (0, $7E7Dk.useState)({
        id: "",
        comment: ""
    });
    const [rejectedTag, setRejectedTag] = (0, $7E7Dk.useState)(null);
    const [tagMessage, setTagMessage] = (0, $7E7Dk.useState)({
        type: null,
        message: null
    });
    const [tagError, setTagError] = (0, $7E7Dk.useState)([]);
    (0, $7E7Dk.useEffect)(()=>{
        setRfidOne({
            id: rfid1?.tagId ?? "",
            comment: rfid1?.tagComment ?? ""
        });
        setRfidTwo({
            id: rfid2?.tagId ?? "",
            comment: rfid2?.tagComment ?? ""
        });
        setRfidThree({
            id: rfid3?.tagId ?? "",
            comment: rfid3?.tagComment ?? ""
        });
    }, [
        rfid1,
        rfid2,
        rfid3
    ]);
    const loadRejectedTagsForUser = (0, $23wDf.default)(()=>(0, $d19ea9236ce7b098$export$2e2bcd8739ae039)().catch(()=>Promise.reject("msgInstallationWizardExitWizardErrorHeading")), [], []);
    (0, $7E7Dk.useEffect)(()=>{
        if (loadRejectedTagsForUser.status === (0, $23wDf.Status).SUCCESS) setRejectedTag(loadRejectedTagsForUser.value);
    }, [
        loadRejectedTagsForUser.status
    ]);
    const updateTagsForUser = (0, $23wDf.default)((tags)=>(0, $88886e07848a83b0$export$2e2bcd8739ae039)(tags).catch(()=>Promise.reject(text("msgRFIDTagsNotUpdated"))));
    (0, $7E7Dk.useEffect)(()=>{
        if (updateTagsForUser.status === (0, $23wDf.Status).SUCCESS) {
            setTagMessage({
                type: "success",
                message: text("msgRFIDTagsUpdated")
            });
            setTimeout(()=>setTagMessage({
                    type: null,
                    message: null
                }), 3000);
            loadRejectedTagsForUser.execute().catch(()=>{});
            getNfcTags.execute().catch(()=>{});
        }
        if (updateTagsForUser.status === (0, $23wDf.Status).ERROR) {
            setTagMessage({
                type: "error",
                message: text("msgRFIDTagsNotUpdated")
            });
            setTimeout(()=>setTagMessage({
                    type: null,
                    message: null
                }), 3000);
        }
    }, [
        updateTagsForUser.status
    ]);
    /**Get tags **/ const getNfcTags = (0, $23wDf.default)(()=>(0, $55d7747fa069f0b8$export$2e2bcd8739ae039)().catch(()=>Promise.reject()));
    (0, $7E7Dk.useEffect)(()=>{
        if (getNfcTags.status === (0, $23wDf.Status).SUCCESS) {
            const tags = getNfcTags.value ?? [];
            setRfidOne({
                id: tags[0]?.id ?? "",
                comment: tags[0]?.comment ?? ""
            });
            setRfidTwo({
                id: tags[1]?.id ?? "",
                comment: tags[1]?.comment ?? ""
            });
            setRfidThree({
                id: tags[2]?.id ?? "",
                comment: tags[2]?.comment ?? ""
            });
        }
    }, [
        getNfcTags.status
    ]);
    /************/ const handleSubmit = (e)=>{
        e.preventDefault();
        const errors = [];
        if (rfidOne.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidOne.id);
            if (!isValid) errors.push({
                type: rfidOne.id,
                message: error.toString()
            });
        }
        if (rfidTwo.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidTwo.id);
            if (!isValid) errors.push({
                type: rfidTwo.id,
                message: error.toString()
            });
        }
        if (rfidThree.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidThree.id);
            if (!isValid) errors.push({
                type: rfidThree.id,
                message: error.toString()
            });
        }
        if (errors.length) {
            setTagError(errors);
            return;
        }
        const nfcTags = [
            rfidThree,
            rfidTwo,
            rfidOne
        ];
        updateTagsForUser.execute(nfcTags).catch(()=>{});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
            code: "lblRFIDWidget",
            dataTestId: "rfidHeader"
        }),
        "data-testid": "rfidContainer"
    }, tagMessage.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: tagMessage.message,
        error: tagMessage.type === "error" ? true : false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SForm, {
        onSubmit: handleSubmit
    }, tagError.find((t)=>t.type === rfidOne.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: tagError.find((t)=>t.type === rfidOne.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidOne.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidOne({
                ...rfidOne,
                id: value
            });
        },
        "data-testid": "tag1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagOneField"),
        type: "text",
        maxLength: 100,
        value: rfidOne.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidOne({
                ...rfidOne,
                comment: value
            });
        },
        "data-testid": "comment1"
    })), tagError.find((t)=>t.type === rfidTwo.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: tagError.find((t)=>t.type === rfidTwo.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidTwo.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidTwo({
                ...rfidTwo,
                id: value
            });
        },
        "data-testid": "tag2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagTwoField"),
        type: "text",
        maxLength: 100,
        value: rfidTwo.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidTwo({
                ...rfidTwo,
                comment: value
            });
        },
        "data-testid": "comment2"
    })), tagError.find((t)=>t.type === rfidThree.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1eyKz.Alert), {
        message: tagError.find((t)=>t.type === rfidThree.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidThree.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidThree({
                ...rfidThree,
                id: value
            });
        },
        "data-testid": "tag3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagThreeField"),
        type: "text",
        maxLength: 100,
        value: rfidThree.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidThree({
                ...rfidThree,
                comment: value
            });
        },
        "data-testid": "comment3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($861b18ca24babdb9$var$SRow, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            alignSelf: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        label: text("btnSave"),
        icon: "pi pi-save",
        loading: updateTagsForUser.status === (0, $23wDf.Status).PENDING,
        disabled: updateTagsForUser.status === (0, $23wDf.Status).PENDING,
        "data-testid": "sumbitBtn"
    })), rejectedTag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblLastRejectedTag",
        values: {
            latestRejected: rejectedTag
        }
    })));
}





var $gJ5zm = parcelRequire("gJ5zm");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $hhXpq = parcelRequire("hhXpq");

var $igvrl = parcelRequire("igvrl");

var $2nOeJ = parcelRequire("2nOeJ");

var $eGlQL = parcelRequire("eGlQL");

var $34PLY = parcelRequire("34PLY");

var $5u6k9 = parcelRequire("5u6k9");

var $4ZuDP = parcelRequire("4ZuDP");

var $eGqzt = parcelRequire("eGqzt");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");

var $c4hCO = parcelRequire("c4hCO");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");
const $5bafa08597a28dee$var$formId = "add-charge-point-form";
function $5bafa08597a28dee$export$58199e6f500a92fe({ visible: visible, onHide: onHide, userId: userId }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: {
            chargePointId: "",
            name: "",
            wifiPassword: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const nameLength = (0, $cCnqE.useWatch)({
        control: control,
        name: "name",
        defaultValue: ""
    }).trim().length;
    const [addChargerToUser, { isLoading: isLoading }] = (0, $1O9Jh.useChargePointSetOwnerMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) reset();
    }, [
        reset,
        visible
    ]);
    const doAddChargerToUser = async (formValues)=>{
        const name = formValues.name.trim();
        try {
            await addChargerToUser({
                userId: userId,
                chargePointId: formValues.chargePointId,
                name: name || formValues.chargePointId,
                wifiPassword: formValues.wifiPassword
            }).unwrap();
            toast.notifySuccess(text("msgChargerWasSuccessfullyAdded"));
            onHide();
        } catch (error) {
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && (error.status === 409 || error.status === 404 || error.status === 403) && error.data && error.data.error) toast.notifyError(error.data.error);
            else toast.notifyError(text("msgChargerNotAddedtoUser"));
        }
    };
    const submitDisabled = isLoading || isSubmitting || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnAddChargerToUser"),
        type: "submit",
        form: $5bafa08597a28dee$var$formId,
        disabled: submitDisabled,
        loading: isLoading || isSubmitting
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        "data-testid": "add-charge-point-dialog",
        header: text("lblAddChargerToUserDialogTitle"),
        visible: visible,
        onHide: onHide,
        footer: footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $5bafa08597a28dee$var$formId,
        "data-testid": "create-modal-form",
        onSubmit: handleSubmit(doAddChargerToUser),
        className: "flex flex-column gap-3",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "serialNumber",
        label: text("lblSerialNumberField"),
        ...register("chargePointId", {
            required: text("msgAddChargePointSerialNumberRequired")
        }),
        error: errors.chargePointId?.message,
        "data-testid": "serialNumber",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "pinCode",
        label: text("lblPin"),
        ...register("wifiPassword", {
            required: text("msgPinCodeRequired")
        }),
        error: errors.wifiPassword?.message,
        "data-testid": "pinCode",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "name",
        label: text("lblName"),
        ...register("name", {
            validate: (value)=>value.trim().length <= (0, $c4hCO.MAX_NAME_LENGTH) || text("lblNameError")
        }),
        error: errors.name?.message,
        subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "flex justify-content-end"
        }, text("msgTextAreaCounter", {
            textCount: nameLength,
            maxLength: (0, $c4hCO.MAX_NAME_LENGTH)
        })),
        "data-testid": "name"
    })));
}




const $46ddb6d276dca8b3$var$StatusIcon = (0, $gRonV.default).span`
    margin-left: 10px;
`;
function $46ddb6d276dca8b3$export$cda9f498fc59d764({ className: className, style: style, chargePoints: chargePoints, loading: loading, removeChargePoint: removeChargePoint, editChargePoint: editChargePoint, user: user }) {
    const text = (0, $5u6k9.default)();
    const [showAddChargePoint, setShowAddChargePoint] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
            code: "lblMyChargersWidget"
        }),
        "data-testid": "myChargers",
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            onClick: ()=>setShowAddChargePoint(true),
            "data-testid": "showAddChargePoint",
            label: text("btnAdd"),
            icon: "pi pi-plus"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "serialNumber"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSerialNumber"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, chargePoints && chargePoints.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: chargePoint.id,
            className: "clickable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($46ddb6d276dca8b3$var$StatusIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("fa fa-wifi", (0, $34PLY.default)(chargePoint) ? "greenFont" : "redFont"),
            title: text((0, $34PLY.default)(chargePoint) ? "lblOnline" : "lblOffline")
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, chargePoint.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `name-${chargePoint.name}`
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex justify-content-end gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            size: "small",
            icon: "pi pi-pencil",
            rounded: true,
            outlined: true,
            severity: "info",
            "aria-label": text("lblEditChargerName"),
            onClick: ()=>{
                editChargePoint(chargePoint);
            },
            "data-testid": "edit-button"
        }), !chargePoint.ownerReadOnly && !chargePoint.companyId && chargePoint.ownerId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            size: "small",
            icon: "pi pi-trash",
            rounded: true,
            outlined: true,
            severity: "danger",
            onClick: ()=>{
                removeChargePoint(chargePoint.id);
            },
            "data-testid": "remove-button"
        }), chargePoint.ownerReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4ZuDP.default), {
            content: "msgChargerCanOnlyBeModifiedByAdministrators"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGqzt.InfoIcon), {
            size: 25,
            "data-testid": "tooltipIcon"
        }))))))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-xsmall margin-bottom-small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5bafa08597a28dee$export$58199e6f500a92fe), {
        visible: showAddChargePoint,
        onHide: ()=>setShowAddChargePoint(false),
        userId: user.id
    }));
}




parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $5u6k9 = parcelRequire("5u6k9");

var $9p3YO = parcelRequire("9p3YO");

var $gUTZf = parcelRequire("gUTZf");
function $df4e3997ba115a37$export$3bf6356b6e1d6999() {
    const text = (0, $5u6k9.default)();
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    const [selectedChargePoint, setSelectedChargePoint] = (0, $7E7Dk.useState)(null);
    const { data: isCompanyMember, isLoading: loadingCompanyMember } = (0, $1O9Jh.useUserLoggedInUserIsCompanyMemberQuery)();
    const { data: userChargePoints, refetch: refetch, isLoading: chargePointLoading } = (0, $1O9Jh.useUserGetOwnedChargePointsQuery)({
        expand: (0, $gUTZf.default).OcppConfig
    });
    const [removeChargePoint] = (0, $1O9Jh.useUserRemoveChargePointAccessMutation)();
    const anyOcppEnabled = userChargePoints?.some((chargePoint)=>chargePoint.ocppEnabled) ?? false;
    const handleRemoveCharger = async (chargePointId)=>{
        if (!chargePointId) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgRemoveCharger"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await removeChargePoint({
                chargePointId: chargePointId
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("msgChargerWasSuccessfullyRemoved"));
        } catch  {
            (0, $r38ZI.notifyError)(text("msgChargerFailedToRemove"));
        }
    };
    const { data: tags, isLoading: loadingNfcTag } = (0, $1O9Jh.useUserGetOwnNfcTagsQuery)();
    const rfidTags = tags?.map((tag)=>({
            tagId: tag.id ?? "",
            tagComment: tag.comment ?? ""
        })) ?? [];
    if (!user) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblProfile",
        className: "profilePage",
        size: "lg",
        "data-testid": "header-profile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-6 margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $0ecb28bf4069333d$export$b7b58f2e100445f7), {
        user: user
    }), !loadingCompanyMember && !isCompanyMember && !anyOcppEnabled && (loadingNfcTag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $861b18ca24babdb9$export$4151436cdd5efa83), {
        rfid1: rfidTags[0],
        rfid2: rfidTags[1],
        rfid3: rfidTags[2]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-6 margin-top-small"
    }, chargePointLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "162px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $46ddb6d276dca8b3$export$cda9f498fc59d764), {
        chargePoints: userChargePoints,
        removeChargePoint: handleRemoveCharger,
        editChargePoint: setSelectedChargePoint,
        loading: chargePointLoading,
        user: user
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gJ5zm.UserProfileLanguageSelect), {
        userId: user.id
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $edf95c8dd73a54c2$export$666b8e5b12c29656), {
        chargePoint: selectedChargePoint,
        visible: Boolean(selectedChargePoint),
        onHide: ()=>setSelectedChargePoint(null),
        onSaveSettled: ()=>refetch(),
        editChargerName: true
    }));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $26yAo = parcelRequire("26yAo");

var $hhXpq = parcelRequire("hhXpq");

var $1O9Jh = parcelRequire("1O9Jh");

var $gUTZf = parcelRequire("gUTZf");

var $2nOeJ = parcelRequire("2nOeJ");

var $j1D7L = parcelRequire("j1D7L");

var $igvrl = parcelRequire("igvrl");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1HK60 = parcelRequire("1HK60");

var $iEUKW = parcelRequire("iEUKW");
const $b32f36ce1d87a5bb$var$SExpandElementContainer = (0, $gRonV.default).div`
    display: flex;
    margin-top: 30px;
`;
const $b32f36ce1d87a5bb$var$STitleContainer = (0, $gRonV.default).div`
    width: 200px;
`;
const $b32f36ce1d87a5bb$var$SChevronContainer = (0, $gRonV.default).div`
    padding-top: 3px;
    margin-left: 20px;
`;
const $b32f36ce1d87a5bb$var$STitleText = (0, $gRonV.default).label`
    width: 200px;
    font-size: 21px;
    font-weight: var(--font-weight-bold);
    line-height: 28px;
    margin-bottom: 0px;
    display: block;
    word-wrap: break-word;
`;
const $b32f36ce1d87a5bb$var$SSubTitleText = (0, $gRonV.default).label`
    font-size: 21px;
    font-weight: var(--font-weight-light);
    line-height: 28px;
    margin-bottom: 0px;
    word-wrap: break-word;
`;
const $b32f36ce1d87a5bb$var$PartnerInfoItem = ({ name: name, email: email, phone: phone, chargerName: chargerName, chargerSerialNumber: chargerSerialNumber })=>{
    const [isExpanded, setIsExpanded] = (0, $7E7Dk.useState)(false);
    if (!chargerSerialNumber) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b32f36ce1d87a5bb$var$SExpandElementContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b32f36ce1d87a5bb$var$STitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b32f36ce1d87a5bb$var$STitleText, {
        "data-testid": "title-text-charger-name-partner-info"
    }, chargerName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b32f36ce1d87a5bb$var$SSubTitleText, {
        "data-testid": "subtitle-text-charger-serial-number-partner-info"
    }, chargerSerialNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b32f36ce1d87a5bb$var$SChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1HK60.default), {
        flipped: isExpanded,
        onClick: ()=>setIsExpanded((prev)=>!prev)
    }))), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iEUKW.default), {
        name: name,
        email: email,
        phone: phone
    }) : null);
};
var $b32f36ce1d87a5bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($b32f36ce1d87a5bb$var$PartnerInfoItem);



var $iEUKW = parcelRequire("iEUKW");

var $5u6k9 = parcelRequire("5u6k9");
const $f405e73eb05bd0e8$var$SSupportDetailsMessage = (0, $gRonV.default).label`
    font-size: 16px;
    line-height: 24px;
    display: block;
    margin-bottom: 40px;
`;
const $f405e73eb05bd0e8$export$612b9760953b2c71 = ()=>{
    const text = (0, $5u6k9.default)();
    const { data: chargePoints, isLoading: isLoading } = (0, $1O9Jh.useUserGetOwnedChargePointsQuery)({
        expand: (0, $gUTZf.default).PartnerInfo
    });
    const chargersWithPartnerInfo = chargePoints?.filter((charger)=>charger.partnerInfo) ?? [];
    const renderItem = ()=>{
        if (chargersWithPartnerInfo.length === 0) return null;
        if (chargersWithPartnerInfo.length === 1) {
            const partnerInfo = chargersWithPartnerInfo[0].partnerInfo;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iEUKW.default), {
                name: partnerInfo?.name,
                email: partnerInfo?.email,
                phone: partnerInfo?.phone
            });
        } else return chargersWithPartnerInfo.map((charger)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $b32f36ce1d87a5bb$export$2e2bcd8739ae039), {
                key: charger.id,
                name: charger.partnerInfo?.name,
                email: charger.partnerInfo?.email,
                phone: charger.partnerInfo?.phone,
                chargerName: charger.name ?? charger.id,
                chargerSerialNumber: charger.id
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblSupport",
        className: "supportPage",
        size: "lg",
        dataTestId: "header-support"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-7 margin-top-small"
    }, !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), null, chargersWithPartnerInfo.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-bottom-large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f405e73eb05bd0e8$var$SSupportDetailsMessage, {
        "data-testid": "support-details-message"
    }, text("msgDetailsOfSupportProvider")), renderItem()) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblFaq"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j1D7L.default), {
        dataTestId: "link-charge-amps-support-page",
        titleCode: "lblChargeAmpsSupportPage",
        href: `https://www.chargeamps.com/${text("linkSupport")}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j1D7L.default), {
        dataTestId: "link-charge-amps-help-center-page",
        titleCode: "lblChargeAmpsHelpCenter",
        href: text("linkHelpCenter")
    }))) : null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-large",
        "data-testid": "loader"
    }))));
};





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $2kyoL = parcelRequire("2kyoL");

var $hhXpq = parcelRequire("hhXpq");

var $23wDf = parcelRequire("23wDf");


var $7YeJw = parcelRequire("7YeJw");

var $Ri8UW = parcelRequire("Ri8UW");
const $bff0409a01e834d3$var$loadChargerUsage = (userId)=>(0, $Ri8UW.default)({
        path: `/stats/users/${userId}/chargerusage`
    });
var $bff0409a01e834d3$export$2e2bcd8739ae039 = $bff0409a01e834d3$var$loadChargerUsage;



var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
const $d1f74aea614e18db$export$eb7dd588cfd00544 = [
    "#8ABFFF",
    "#DDDDDD",
    "#FF8B7C",
    "#006EF0",
    "#178B17",
    "#535353",
    "#DF0017"
];




const $ee3076c89adafaeb$var$Wrapper = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $ee3076c89adafaeb$var$LabelContainer = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    top: 50px;
    right: 0;
    position: absolute;
    max-width: 100px;
    hyphens: auto;
    text-align: left;

    @media screen and (max-width: 1095px) {
        position: relative;
        align-self: flex-start;
        max-width: 200px;
        hyphens: auto;
    }
`;
const $ee3076c89adafaeb$var$Dot = (0, $gRonV.default).div`
    height: 11px;
    width: 11px;
    margin: 1px 4px;
    background-color: ${({ color: color })=>color};
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
`;
const $ee3076c89adafaeb$var$Label = (0, $gRonV.default).span`
    font-size: 14px;
    display: flex;
    transition: 0.2s all ease;
    color: ${({ theme: theme })=>theme.font.darkestColor};

    &.selected {
        ${$ee3076c89adafaeb$var$Dot} {
            filter: opacity(70%);
        }
        text-decoration: underline;
    }

    &:hover {
        cursor: default;
    }
`;
const $ee3076c89adafaeb$var$Path = (0, $gRonV.default).path`
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: dash 1.5s linear forwards;
    transition: 0.2s all ease;

    &:hover {
        filter: opacity(70%);
        cursor: pointer;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }
`;
const $ee3076c89adafaeb$var$Text = (0, $gRonV.default).span`
    position: absolute;
    font-size: 24px;
`;
function $ee3076c89adafaeb$var$Donut(cx, cy, radius, data) {
    if (!data) return;
    function arcradius(cx, cy, radius, degrees) {
        const radians = (degrees - 90) * Math.PI / 180.0;
        return {
            x: cx + radius * Math.cos(radians),
            y: cy + radius * Math.sin(radians)
        };
    }
    let total = 0;
    const arr = [];
    let beg = 0;
    let end = 0;
    let count = 0;
    for(let i = 0; i < data.length; i++)total += data[i].percentage;
    for(let i = 0; i < data.length; i++){
        const item = data[i];
        const tmp = {
            index: 0,
            value: 0,
            d: "",
            text: ""
        };
        let p = Math.floor((item.percentage + 1) / total * 100);
        count += p;
        if (i === length - 1 && count < 100) p = p + (100 - count);
        end = beg + 3.6 * p;
        tmp.index = i;
        tmp.value = item.percentage;
        const b = arcradius(cx, cy, radius, end);
        const e = arcradius(cx, cy, radius, beg);
        const la = end - beg <= 180 ? 0 : 1;
        tmp.d = [
            "M",
            Math.floor(b.x),
            Math.floor(b.y),
            "A",
            radius,
            radius,
            0,
            la,
            0,
            i === 0 ? Math.floor(e.x) + 7 : Math.floor(e.x),
            Math.floor(e.y)
        ].join(" ");
        tmp.text = item.chargePointName;
        arr.push(tmp);
        beg = end;
    }
    return arr;
}
const $ee3076c89adafaeb$export$f19986a384ea910d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function DoughnutChart({ className: className, style: style, data: data }) {
    const centerX = 100;
    const centerY = 100;
    const radius = 70;
    const [showInfo, setShowInfo] = (0, $7E7Dk.useState)({
        text: "",
        label: ""
    });
    const arr = $ee3076c89adafaeb$var$Donut(centerX, centerY, radius, data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Wrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        id: "svg",
        width: "200",
        height: "200"
    }, arr?.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Path, {
            d: p.d,
            stroke: (0, $d1f74aea614e18db$export$eb7dd588cfd00544)[i],
            fill: "none",
            strokeWidth: "25",
            onMouseEnter: ()=>setShowInfo({
                    text: `${p.value}%`,
                    label: p.text
                }),
            onMouseLeave: ()=>setShowInfo({
                    text: "",
                    label: ""
                }),
            "data-testid": "path-" + p.text
        })))), showInfo.text.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Text, {
        "data-testid": "percentage-text"
    }, showInfo.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$LabelContainer, null, arr?.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Label, {
            key: p.text,
            color: (0, $d1f74aea614e18db$export$eb7dd588cfd00544)[i],
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
                selected: showInfo.label === p.text
            }),
            "data-testid": "label-" + p.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ee3076c89adafaeb$var$Dot, {
            color: (0, $d1f74aea614e18db$export$eb7dd588cfd00544)[i]
        }), p.text))));
});





var $igvrl = parcelRequire("igvrl");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $hhXpq = parcelRequire("hhXpq");

var $7D5nE = parcelRequire("7D5nE");

var $5u6k9 = parcelRequire("5u6k9");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $igvrl = parcelRequire("igvrl");
const $c53f372ffcfe0c5a$export$2a9b515c57b6776b = ({ visible: visible, onHide: onHide })=>{
    const text = (0, $5u6k9.default)();
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: onHide
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("btnHelp"),
        footer: footer,
        "data-testid": "statistics-help-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgStatisticsHelp"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "mb-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgStatisticHelpDownload"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "inline-flex align-items-center ml-1 p-1 border-round bg-primary text-primary-color"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "pi pi-download"
    }))));
};




const $889a6fbd1d51896b$export$8ff0b497c55bd560 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserAppStatisticsTotalConsumptionWidget({ download: download, downloadLoading: downloadLoading, reloadChart: reloadChart, data: data, useMonth: useMonth }) {
    const text = (0, $5u6k9.default)();
    const [showInfo, setShowInfo] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblTotalConsumption",
        dataTestId: "total-consumtion-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        size: "small",
        label: text("msgDownloadAsCSV"),
        icon: "pi pi-download",
        tooltip: text("msgDownloadAsCSV"),
        tooltipOptions: {
            position: "top"
        },
        loading: downloadLoading,
        onClick: download,
        "data-testid": "download"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        size: "small",
        label: text("btnHelp"),
        icon: "pi pi-question-circle",
        outlined: true,
        tooltip: text("btnHelp"),
        tooltipOptions: {
            position: "top"
        },
        onClick: ()=>setShowInfo(true)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row flex justify-content-end mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("select", {
        className: "form-control",
        onChange: (e)=>reloadChart(e.target.value),
        required: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("option", {
        value: "currentmonth"
    }, text("msgThisMonthOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("option", {
        value: "lastmonth"
    }, text("msgLastMonthOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("option", {
        value: "currentyear"
    }, text("msgThisYearOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("option", {
        value: "lastyear"
    }, text("msgLastYearOption"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7D5nE.BarChart), {
        barChartId: "dygraphStatistic",
        data: data,
        useMonth: useMonth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c53f372ffcfe0c5a$export$2a9b515c57b6776b), {
        visible: showInfo,
        onHide: ()=>setShowInfo(false)
    }));
});





var $Ri8UW = parcelRequire("Ri8UW");
const $7ec7127a959fd8bb$var$loadReportForUser = (reportId, chargePointUserId, interval, timeZone)=>(0, $Ri8UW.default)({
        path: `/reports/${reportId}`,
        query: {
            chargePointUserId: chargePointUserId,
            interval: interval,
            timeZone: timeZone
        }
    });
var $7ec7127a959fd8bb$export$2e2bcd8739ae039 = $7ec7127a959fd8bb$var$loadReportForUser;



var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $2nOeJ = parcelRequire("2nOeJ");

var $igvrl = parcelRequire("igvrl");

var $eGlQL = parcelRequire("eGlQL");

var $5u6k9 = parcelRequire("5u6k9");
function $b50788aa6bea0fa8$export$fce5dc8b070767c({ devices: devices, className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblMeasurementDeviceProperties"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblDescription"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblActive"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblMaxCurrent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblStatus"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, devices?.map((device)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "deviceName"
        }, device.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "deviceDescription"
        }, device.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, device.active?.toString() ?? ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, device.loadBalancerGroupSupplyMaxCurrent || "---", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblAmpereShort"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, device.status))))));
}





var $51TcK = parcelRequire("51TcK");
parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $20ecU = parcelRequire("20ecU");
const $ff9f16c7ae8350cf$var$Container = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    gap: 56px;
`;
const $ff9f16c7ae8350cf$export$bacd47cfcd142d32 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserAppStatisticPage({ style: style }) {
    const text = (0, $5u6k9.default)();
    const user = (0, $20ecU.useSessionUser)();
    const userId = user.id;
    const [chargingSessionsOffset, setChargingSessionsOffset] = (0, $7E7Dk.useState)(0);
    const [charginsSessions, setChargingSessions] = (0, $7E7Dk.useState)([]);
    const [selectedInterval, setSelectedInterval] = (0, $7E7Dk.useState)("currentmonth");
    const [loadingDownload, setLoadingDownload] = (0, $7E7Dk.useState)(false);
    /** Get charging sessions **/ const { data: chargingSessionsData, isFetching: loadingChargingSessions } = (0, $1O9Jh.useChargingSessionGetChargingSessionsForCurrentUserQuery)({
        offset: chargingSessionsOffset,
        noOfItems: (0, $fd75723863ee2054$export$c9346c8390d51ce8)
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (chargingSessionsData) setChargingSessions((currentSessions)=>currentSessions.length ? currentSessions.concat(chargingSessionsData) : chargingSessionsData);
    }, [
        chargingSessionsData
    ]);
    const loadMoreSessions = ()=>{
        setChargingSessionsOffset((currentOffset)=>currentOffset + (0, $fd75723863ee2054$export$c9346c8390d51ce8));
    };
    /***************************/ /** Get user statistics **/ const { data: userStatistic } = (0, $1O9Jh.useStatisticsGetUserUsageStatisticsQuery)({
        userId: userId
    }, {
        skip: !userId
    });
    /************************/ /** Get charger usage **/ const getChargerUsage = (0, $23wDf.default)((userId)=>{
        if (userId) return (0, $bff0409a01e834d3$export$2e2bcd8739ae039)(userId);
    }, [], [
        user?.id
    ]);
    /***********************/ /** get user total consumption **/ const { data: totalConsumtionData, isLoading: loadingConsumption } = (0, $1O9Jh.useStatisticsGetUserTotalConsumptionQuery)({
        userId: userId,
        interval: selectedInterval
    }, {
        skip: !userId
    });
    /********************************/ /** Download data **/ const downloadData = ()=>{
        if (!userId) return;
        setLoadingDownload(true);
        const tz = (0, (/*@__PURE__*/$parcel$interopDefault($2kyoL))).determine();
        const timeZone = tz.name();
        let fileName = "";
        switch(selectedInterval){
            case "currentmonth":
                fileName = text("msgThisMonthOption");
                break;
            case "lastmonth":
                fileName = text("msgLastMonthOption");
                break;
            case "currentyear":
                fileName = text("msgThisYearOption");
                break;
            default:
                fileName = text("msgLastYearOption");
                break;
        }
        (0, $7ec7127a959fd8bb$export$2e2bcd8739ae039)(100, user.id, selectedInterval, timeZone).then((report)=>{
            let csvData = "\uFEFF" + report.formattedData;
            if (!report.formattedData || report.formattedData.length === 0) csvData = "\uFEFFN/A";
            const file = new Blob([
                csvData
            ], {
                type: "application/txt"
            });
            const anchor = Object.assign(document.createElement("a"), {
                href: URL.createObjectURL(file),
                target: "_blank",
                download: fileName + ".csv",
                style: "display: none"
            });
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setLoadingDownload(false);
        }, ()=>{
            console.error("could not load report data");
        });
    };
    /*******************/ const { data: measurementDevices = [], isFetching: isFetching } = (0, $1O9Jh.useMeasurementDevicesGetDevicesByUserIdQuery)({
        userId: userId
    }, {
        skip: !userId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblStatistics",
        size: "lg",
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row margin-bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ff9f16c7ae8350cf$var$Container, {
        className: "col-xs-12 col-md-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $889a6fbd1d51896b$export$8ff0b497c55bd560), {
        download: ()=>downloadData(),
        downloadLoading: loadingDownload,
        reloadChart: (type)=>{
            setSelectedInterval(type);
        },
        data: totalConsumtionData ?? [],
        useMonth: selectedInterval === "currentyear" || selectedInterval === "lastyear"
    }), loadingConsumption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "360px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fd75723863ee2054$export$d96ee243323785bc), {
        sessions: charginsSessions,
        showEndTime: true,
        loadMoreChargingSessions: ()=>loadMoreSessions(),
        loading: loadingChargingSessions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-4 margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "dashboard-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblMostFrequentChargers"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ee3076c89adafaeb$export$f19986a384ea910d), {
        data: getChargerUsage.value ?? []
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7YeJw.ChargingStatistics), {
        stats: userStatistic,
        direction: "column"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-6"
    }, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "200px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $b50788aa6bea0fa8$export$fce5dc8b070767c), {
        devices: measurementDevices
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $51TcK.LoadBalancerStatistics), {
        device: measurementDevices?.[0]
    }));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $grlRk = parcelRequire("grlRk");
const $6049bd56fe4e86c8$export$a4bf597a1fb62466 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $grlRk.ChargePointSchedulesPage), null));





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $2eCtI = parcelRequire("2eCtI");
const $1b33c4de4b3f61fe$var$MENU_LINKS = [
    {
        href: "/dashboard",
        labelCode: "btnHome"
    },
    {
        href: "/user-profile",
        labelCode: "lblProfile"
    },
    {
        href: "/statistics",
        labelCode: "lblStatistics"
    },
    {
        href: "/remotecontrol",
        labelCode: "btnRemoteControl"
    },
    {
        href: "/support",
        labelCode: "lblSupport"
    }
];
function $1b33c4de4b3f61fe$export$6e8e699acb89c2ad({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2eCtI.PageHeader), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        links: $1b33c4de4b3f61fe$var$MENU_LINKS
    });
}




const $b7775bd5872aeac9$var$RequireAuth = ({ children: children, isHeaderShown: isHeaderShown = true, sessionStatus: sessionStatus })=>{
    const location = (0, $3um4r.useLocation)();
    if (sessionStatus === "loading") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kNBIm.PortalSessionLoader), null);
    return sessionStatus === "authenticated" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, isHeaderShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "page-layout-header py-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1b33c4de4b3f61fe$export$6e8e699acb89c2ad), null)), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Navigate), {
        to: "/login",
        state: {
            from: location.pathname
        },
        replace: true
    });
};
const $b7775bd5872aeac9$var$App = ()=>{
    const sessionStatus = (0, $PmdvF.usePortalSession)();
    const location = (0, $3um4r.useLocation)();
    (0, $7E7Dk.useLayoutEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "/*",
        element: sessionStatus === "loading" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kNBIm.PortalSessionLoader), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Navigate), {
            to: sessionStatus === "authenticated" ? "/dashboard" : "/login"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "login",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9Rf8k.SignInPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f0ov8.PasswordResetPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user-agreement",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $37095695afb1ca08$export$5573dc5ce5740818), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aojuQ.ResetPasswordRequestPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dm5pM.ResetPasswordRequestSuccessPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request-error",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $a4GLo.ResetPasswordRequestErrorPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "register-user",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $36ebc4f4d79428f0$export$265471dcab9022d3), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "dashboard",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $92985d883f00a125$export$ab6746011d315456), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "registerchargepoint",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            isHeaderShown: false,
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $65ef790a4de7c061$export$4a4cbf17073b70ff), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "remotecontrol",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8e6378fbf8e335fa$export$31f6100da20592ef), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "remotecontrol/:chargePointId/schedule",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6049bd56fe4e86c8$export$a4bf597a1fb62466), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user-profile",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $df4e3997ba115a37$export$3bf6356b6e1d6999), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "support",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f405e73eb05bd0e8$export$612b9760953b2c71), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "statistics",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b7775bd5872aeac9$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ff9f16c7ae8350cf$export$bacd47cfcd142d32), null))
    }));
};
var $b7775bd5872aeac9$export$2e2bcd8739ae039 = $b7775bd5872aeac9$var$App;


(0, $1IBeB.initAuthChangeListener)();
const $5cb66537426355d6$var$root = (0, $9Sg2u.createRoot)(document.getElementById("root"));
$5cb66537426355d6$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1iD12.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7E7Dk.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aLIw2.LocalizationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2rQNl.Provider), {
    store: (0, $70f912f5d483b5ef$export$6f57813fe9f31bf9)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eHYdO.PrimeReactProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aCffN.ToastProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.BrowserRouter), {
    basename: "userapp"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $b7775bd5872aeac9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9p3YO.ConfirmDialog), null)))))))));


//# sourceMappingURL=index.52dc8c3d.js.map
